import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import Modal from './Modal';
import Input from '../shared/Input';
import Button from '../shared/Button';

const ForgotPasswordModal = ({ open, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    if (e.keyCode === 13) {
      setEmail('');
      onSubmit(email);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setEmail('');
        onClose();
      }}
      onSubmit={() => {
        onSubmit(email);
        setEmail('');
      }}
      title="Forgot your password?"
      disabled={!email.length}
      size="xs"
      autoSize
    >
      <div className="p-lg">
        <div className="secondary m-b-sm">
          Enter your email and we'll send you details on how to reset your password.
        </div>
        <Box sx={{ mt: 1 }}>
          <Input
            id="email"
            type="email"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleSubmit}
          />
        </Box>
        <div className="actions m-t-lg d-flex flex-end">
          <Button
            type="submit"
            onClick={() => onSubmit(email)}
            variant="contained"
            color="primary"
            disabled={!email.length}
            text="Reset Password"
          />
        </div>
      </div>
    </Modal>
  );
};

ForgotPasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ForgotPasswordModal;
